/*
 * File: ClinicalApp.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles the selection of the clinical item in the patient app
 */
import React, { useState, useEffect, useCallback } from "react";
import Router from "components/Router";
import ClinicalStore from "./Store";
import ClinicalPages from "./ClinicalPages";
import Clinical from "./Clinical";
import PatientChart from "../topofthechart/PatientChart";
import { useStore } from "utils/useStore";

const routes = [
  {
    path: "/patients/:patientId/clinical",
    component: Clinical,
    exact: true
  },
  {
    path: "/patients/:patientId/clinical/:widget",
    component: ClinicalPages
  }
];

const ClinicalApp = () => {
  const [loading, setLoading] = useState(true);
  const clinical = useStore(ClinicalStore);

  const init = useCallback(async () => {
    await clinical.fetchClinicalCounts();
    setLoading(false);
  }, [clinical]);

  useEffect(() => {
    init();
  }, [init]);

  if (loading) return null;
  return (
    <div>
      <PatientChart />
      <Router routes={routes} />
    </div>
  );
};

export default ClinicalApp;
